import { DatePipe } from '@angular/common';
import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

// Service
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { CommonService } from './../../../../services/common/common.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { SubstitutionOrderReportService } from './../../../../services/seed/reports/substitution-order-report.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';

// Other
import { MasterConstants } from '../../../../common/constants/master-constants';
import { DashboardFilter } from '../../../../models/DashboardFilter';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { ReportType } from '../../../../models/report-type.model';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';

@Component({
  selector: 'app-substitution-order-report',
  templateUrl: './substitution-order-report.component.html',
  styleUrls: ['./substitution-order-report.component.scss'],
  providers: [SubstitutionOrderReportService]
})

export class SubstitutionOrderReportComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();

  private readonly originalDisplayedColumns: any[] = [
    { headertxt: "Order Number", columnfield: "dealerOrderNumber", className: 'mat-header-cell orderNumber text-center', tdClassName: 'mat-cell orderNoText text-center' },
    { headertxt: "Account", columnfield: "accountNumber", className: 'mat-header-cell accountNumber text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Account Name", columnfield: "accountName", className: 'mat-header-cell accountName text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Account City", columnfield: "city", className: 'mat-header-cell city text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Account State", columnfield: "state", className: 'mat-header-cell state text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "From Product Number", columnfield: "fromProductNumber", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "From Product Name", columnfield: "fromProductName", className: 'mat-header-cell itemDescription text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "From Treatment", columnfield: "fromTreatment", className: 'mat-header-cell treatment text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "From Seed Size", columnfield: "fromSeedSize", className: 'mat-header-cell seedSize text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "From Package Size", columnfield: "fromPackageSize", className: 'mat-header-cell packageSize text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "From Qty Cancelled", columnfield: "fromQtyCancelled", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "To Product Number", columnfield: "toProductNumber", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "To Product Name", columnfield: "toProductName", className: 'mat-header-cell itemDescription text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "To Treatment", columnfield: "toTreatment", className: 'mat-header-cell treatment text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "To Seed Size", columnfield: "toSeedSize", className: 'mat-header-cell seedSize text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "To Package Size", columnfield: "toPackageSize", className: 'mat-header-cell packageSize text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Quantity Substituted", columnfield: "toQtyTransfered", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Remaining Product Number", columnfield: "remainingProductNumber", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Remaining Product Name", columnfield: "remainingProductName", className: 'mat-header-cell itemDescription text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Remaining Treatment", columnfield: "remainingTreatment", className: 'mat-header-cell treatment text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Remaining Seed Size", columnfield: "remainingSeedSize", className: 'mat-header-cell seedSize text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Remaining Package Size", columnfield: "remainingPackageSize", className: 'mat-header-cell packageSize text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Remaining Quantity", columnfield: "remainingQtyTransfered", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
    { headertxt: "Substitution Date", columnfield: "substitutionDate", className: 'mat-header-cell packageSize text-center', tdClassName: 'mat-cell text-center' },
  ];
  public currentFilter = new UserReportFilter();

  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  searchValue = '';
  selectedValue: string;
  filterList: any;
  productList: any;
  accountId: number;
  validateEvolveData: any;
  previousSelectedValue: string;
  isEvolveAccountRestriction = false;
  partialSearchValue = '';
  isTextBoxEmpty = true;
  export: boolean;
  pageName = 'SubstitutionOrderReport';
  filterValueList = new Array();
  fromSubstitutionDateFilter: any;
  toSubstitutionDateFilter: any;

  productCategoryMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  treatmentMasterList: any = [];
  productLineMasterList: any = [];
  stateMasterList: any = [];
  accountNoList: any = [];

  totalRecords = 0;

  filter: SubstitutionOrderReportFilter = new SubstitutionOrderReportFilter();

  searchTypeList: string[] = ['Parent Account No', 'Account No', 'Account Name', 'City', 'State/ Province', 'Product Name', 'Marketing Brand',
    'Product Line', 'Seed Size', 'Package Size', 'Treatment', 'Technology', 'Order No', 'Substitution Date'];

  // HTML Table
  headerDS: any[] = [];
  bodyDS: any[] = [];
  paginatorDS: any[] = [];

  // MatPaginator Inputs
  length = 0;
  pageSize = 50;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private broadcastService: BroadcastService,
    private configService: ConfigService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private substitutionOrderReportService: SubstitutionOrderReportService,
    private excelService: ExcelService,
    private toastrService: ToastrService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService) {
    // set table headers
    this.headerDS = this.originalDisplayedColumns;
  }

  // OnInit
  ngOnInit() {
    if (this.activatedRoute.snapshot.data['evoleAccess']) {
    }
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    }

    if (this.validateEvolveData != undefined) {
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;

      this.searchTypeList = ['Parent Account No', 'Account No', 'Account Name', 'City', 'State/ Province', 'Product Name', 'Marketing Brand',
        'Product Line', 'Seed Size', 'Package Size', 'Treatment', 'Technology', 'Order No', 'Substitution Date'];
    }

    this.loadMasterData();
    this.resetFilter();
    this.selectedValue = this.searchTypeList[0];

    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          this.currentFilter = filter;
          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          this.filterList = filters.filterOption;

          let filterHeader = []
          filters.displayedColumns.forEach(d => {
            let displayColumn = this.originalDisplayedColumns.filter(x => x.columnfield == d.columnfield);
            if (displayColumn && displayColumn[0]) {
              //fix column at first position
              if (displayColumn[0].columnfield == 'dealerOrderNumber') {
                filterHeader.unshift(displayColumn[0]);
              }
              else {
                filterHeader.push(displayColumn[0]);
              }
            }
          });
          this.headerDS = filterHeader;
          this.getFilterData();
        }
        else {
          if (filter && filter.filterDescription === this.currentFilter.filterDescription || !filter)
            this.currentFilter = new UserReportFilter();
        }
      }));
  }

  ngOnDestroy() {
    this.userReportFilterSliderService.resetFilter();

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        this.filterList.Brand = null;
        this.filter.productName = null;
        break;
      case 'Technology':
        this.filterList.Technology = [];
        this.filter.productCategory = null;
        break;
      case 'Marketing Brand':
        this.filterList.MarketingBrandList = [];
        this.filter.marketingBrand = null;
        break;
      case 'Product Line':
        this.filterList.ProductLineList = [];
        this.filter.productLine = null;
        break;
      case 'Seed Size':
        this.filterList.SeedSizeList = [];
        this.filter.seedSize = null;
        break;
      case 'Package Size':
        this.filterList.PackageSizeList = [];
        this.filter.packageSize = null;
        break;
      case 'Treatment':
        this.filterList.TreatmentList = [];
        this.filter.treatment = null;
        break;
      case 'Parent Account No':
        this.filterList.ParentNo = null;
        this.filter.parentNo = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.filterList.AccountNo = [];
        }
        else {
          this.filterList.TxtAccountNo = null;
        }
        this.filterList.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.filterList.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'Order No':
        this.filterList.OrderId = null;
        this.filter.orderNumber = null;
        break;
      case 'Substitution Date':
        this.filterList.FromSubstitutionDate = null;
        this.filterList.ToSubstitutionDate = null;
        this.filter.fromSubstitutionDate = null;
        this.filter.toSubstitutionDate = null;
        this.fromSubstitutionDateFilter = '';
        this.toSubstitutionDateFilter = '';
        break;
      case 'City':
        this.filterList.City = null;
        this.filter.city = null;
        break;
      case 'State':
        this.filterList.State = [];
        this.filter.state = null;
        break;
      default:
        break;
    }
  }

  // Enable disable search
  enableDisableSearch() {
    if (this.validateProductFilter(this.filterList)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Product search
  validateProductSearch() {
    // To Validate Brand
    if (this.filterList.Brand !== null && this.filterList.Brand !== '' && this.filterList.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate City
    else if (this.filterList.City !== null && this.filterList.City !== '' && this.filterList.City.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate Account Name
    else if (this.filterList.AccountName !== null && this.filterList.AccountName !== '' && this.filterList.AccountName.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate Order No
    else if (this.filterList.OrderId !== null && this.filterList.OrderId !== '' && this.filterList.OrderId.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate Parent Account Number
    else if (this.filterList.ParentNo !== null && this.filterList.ParentNo !== '' && this.filterList.ParentNo.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate text account no
    else if (this.filterList.TxtAccountNo !== null && this.filterList.TxtAccountNo !== '' && this.filterList.TxtAccountNo.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Load Master data
  loadMasterData() {
    // ProductCategory master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST)) {
      this.productCategoryMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_CATEGORY_MASTER_LIST));
    }

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.ALL_SEED_SIZE_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_SEED_SIZE_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    this.subscription.push(this.commonService.getReportFilterDDLValues(this.headerYear).subscribe(result => {
      const data = result as commonDDL;
      this.stateMasterList = data.states;
      this.accountNoList = data.accounts;
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); }));
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);

      if (this.filterValueList.length < 1) {
        // TO Do clear grid data
        this.bodyDS = [];
        this.setPaginatorDS();
        this.paginator.firstPage();
      }
      this.enableDisableSearch();
    }
  }

  //Select filter
  public selectFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.SubstitutionOrderReport, 0, this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt)), newFilter);
  }

  //Add filter
  public addFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.SubstitutionOrderReport, 1, this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt)), newFilter);
  }

  public editFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList,
      displayedColumns: this.headerDS.map(x => new ColumnDescription(x.columnfield, x.headertxt))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 1, this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt)), this.currentFilter);
  }

  public save(): void {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList,
      displayedColumns: this.headerDS.map(x => new ColumnDescription(x.columnfield, x.headertxt))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
    else {
      this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
  }

  //To validate product filter
  validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate ProductCategory
    if (productFilter.Technology !== null && productFilter.Technology !== '' && productFilter.Technology.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Validate Order No
    if (productFilter.OrderId !== null && productFilter.OrderId !== '' && productFilter.OrderId.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate text Account no
    if (productFilter.TxtAccountNo !== null && productFilter.TxtAccountNo !== '' && productFilter.TxtAccountNo.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate ParentNo
    if (productFilter.ParentNo !== null && productFilter.ParentNo !== '' && productFilter.ParentNo.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Account No
    if (productFilter.AccountNo != null && productFilter.AccountNo.length > 0) {
      isValid = true;
    }

    // To Validate Account Name
    if (productFilter.AccountName !== null && productFilter.AccountName !== '' && productFilter.AccountName.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate City
    if (productFilter.City !== null && productFilter.City !== '' && productFilter.City.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate State
    if (productFilter.State != null && productFilter.State.length > 0) {
      isValid = true;
    }

    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.Technology == null)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ParentNo == null)
      && productFilter.OrderId == null
      && productFilter.TxtAccountNo == null
      && (productFilter.AccountNo == null || productFilter.AccountNo.length <= 0)
      && productFilter.AccountName == null
      && productFilter.City == null
      && (productFilter.State == null || productFilter.State.length <= 0)
    ) {
      isValid = false;
    }
    return isValid;
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.isTextBoxEmpty = true;
    this.resetFilter();
    this.validateSubstitutionDateFilter('clearAll', '');
    const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.currentFilter = new UserReportFilter();
    this.userReportFilterSliderService.resetFilter();
    this.searchTypeList = ['Parent Account No', 'Account No', 'Account Name', 'City', 'State/ Province', 'Product Name', 'Marketing Brand',
      'Product Line', 'Seed Size', 'Package Size', 'Treatment', 'Technology', 'Order No', 'Substitution Date'];
    this.headerDS = this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt));
    // To Do clear data grid
    this.bodyDS = [];
    this.setPaginatorDS();
    this.paginator.firstPage();
  }

  // Reset Product Filter
  resetFilter() {
    this.filterList = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'Brand': null,
      'City': null,
      'OrderId': null,
      'AccountName': null,
      'ParentNo': null,
      'TxtAccountNo': null,
      'State': [],
      'AccountNo': [],
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'DistrictList': [],
      'PackageSizeList': [],
      'TreatmentList': [],
      'ProductLineList': [],
      'FromSubstitutionDate': null,
      'ToSubstitutionDate': null,
      'Technology': null
    };
  }

  validateInputText() {
    const accountRegx = RegExp('^[0-9, ]+$');
    const orderIdRegx = RegExp('^[a-zA-Z0-9, ]+$');
    const cityRegx = RegExp('^[a-zA-Z0-9, ]+$');

    return (this.filterList.TxtAccountNo ? accountRegx.test(this.filterList.TxtAccountNo) : true &&
      this.filterList.ParentNo ? accountRegx.test(this.filterList.ParentNo) : true &&
        this.filterList.OrderId ? orderIdRegx.test(this.filterList.OrderId) : true &&
          this.filterList.City ? cityRegx.test(this.filterList.City) : true);
  }

  // Keep filter values
  keepFilter() {
    if (!this.validateInputText()) {
      this.toastrService.error('Invalid Input.');
      return false;
    }

    if (this.filterValueList) {
      let selectedIds = '';

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.filterList) {
        // Brand
        if (this.filterList.Brand && this.filterList.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.filterList.Brand);
          this.filter.productName = this.filterList.Brand;
        }
        else {
          this.filter.productName = null;
        }

        // Marketing Brand
        if (this.filterList.MarketingBrandList && this.filterList.MarketingBrandList.length > 0) {
          let strMB = '';
          this.filterList.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));

          selectedIds = '';
          this.marketingMasterList.forEach(x => {
            if (this.filterList.MarketingBrandList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.marketingBrand = selectedIds;
        }
        else {
          this.filter.marketingBrand = null;
        }

        // Technology
        if (this.filterList.Technology && this.filterList.Technology != '') {
          this.filterValueList.push('Technology : ' + this.filterList.Technology);
          this.filter.productCategory = this.filterList.Technology;
        }
        else {
          this.filter.productCategory = null;
        }

        // Product Line
        if (this.filterList.ProductLineList && this.filterList.ProductLineList.length > 0) {
          let strPL = '';
          this.filterList.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));

          selectedIds = '';
          this.productLineMasterList.forEach(x => {
            if (this.filterList.ProductLineList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.productLine = selectedIds;
        }
        else {
          this.filter.productLine = null;
        }

        // Seed Size
        if (this.filterList.SeedSizeList && this.filterList.SeedSizeList.length > 0) {
          let strSS = '';
          this.filterList.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));

          selectedIds = '';
          this.seedsizeMasterList.forEach(x => {
            if (this.filterList.SeedSizeList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.seedSize = selectedIds;
        }
        else {
          this.filter.seedSize = null;
        }

        // Package Size
        if (this.filterList.PackageSizeList && this.filterList.PackageSizeList.length > 0) {
          let strPS = '';
          this.filterList.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
          selectedIds = '';
          this.packagesizeMasterList.forEach(x => {
            if (this.filterList.PackageSizeList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.packageSize = selectedIds;
        }
        else {
          this.filter.packageSize = null;
        }

        // Treatment
        if (this.filterList.TreatmentList && this.filterList.TreatmentList.length > 0) {
          let strTreat = '';
          this.filterList.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));

          selectedIds = '';
          this.treatmentMasterList.forEach(x => {
            if (this.filterList.TreatmentList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.treatment = selectedIds;
        }
        else {
          this.filter.treatment = null;
        }

        // Parent Account No
        if (this.filterList.ParentNo && this.filterList.ParentNo != '') {
          this.filterValueList.push('Parent Account No : ' + this.filterList.ParentNo);
          this.filter.parentNo = this.filterList.ParentNo;
        }
        else {
          this.filter.parentNo = null;
        }

        // text Account No
        if (this.filterList.TxtAccountNo && this.filterList.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.filterList.TxtAccountNo);
          this.filter.account = this.filterList.TxtAccountNo;
        }
        else if (this.filterList.AccountNo && this.filterList.AccountNo.length > 0) {
          let strAct = '';
          this.filterList.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });
          this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          this.filter.account = strAct;
        }
        else {
          this.filter.account = null;
        }

        // Account Name
        if (this.filterList.AccountName && this.filterList.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.filterList.AccountName);
          this.filter.accountName = this.filterList.AccountName;
        }
        else {
          this.filter.accountName = null;
        }

        // Order No
        if (this.filterList.OrderId && this.filterList.OrderId != '') {
          this.filterValueList.push('Order No : ' + this.filterList.OrderId);
          this.filter.orderNumber = this.filterList.OrderId;
        } else {
          this.filter.orderNumber = null;
        }

        // Substitution Date
        if (this.filterList.FromSubstitutionDate && this.filterList.FromSubstitutionDate != null && this.filterList.ToSubstitutionDate && this.filterList.ToSubstitutionDate != null) {
          this.filterValueList.push('Substitution Date : (' + this.datePipe.transform(this.filterList.FromSubstitutionDate, 'MM/dd/yyyy') + ') - (' + this.datePipe.transform(this.filterList.ToSubstitutionDate, 'MM/dd/yyyy') + ')');
          this.filter.fromSubstitutionDate = new Date(this.filterList.FromSubstitutionDate).toDateString();
          this.filter.toSubstitutionDate = new Date(this.filterList.ToSubstitutionDate).toDateString();
        } else {
          this.filter.fromSubstitutionDate = null;
          this.filter.toSubstitutionDate = null;
        }

        // City
        if (this.filterList.City && this.filterList.City != '') {
          this.filterValueList.push('City : ' + this.filterList.City);
          this.filter.city = this.filterList.City;
        } else {
          this.filter.city = null;
        }

        // State
        if (this.filterList.State && this.filterList.State.length > 0) {
          let strSt = '';
          this.filterList.State.forEach(x => {
            strSt = strSt + x + ', ';
          });
          this.filterValueList.push('State : ' + strSt.substr(0, strSt.length - 2));

          selectedIds = '';
          this.stateMasterList.forEach(x => {
            if (this.filterList.State.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.state = selectedIds;
        } else {
          this.filter.state = null;
        }
      }
    }

    if (this.filterList && (this.filterList.Brand != null && this.filterList.Brand !== '') ||
      (this.filterList.MarketingBrandList && this.filterList.MarketingBrandList.length > 0) ||
      (this.filterList.Technology && (this.filterList.Technology != null && this.filterList.Technology !== '')) ||
      (this.filterList.ProductLineList && this.filterList.ProductLineList.length > 0) ||
      (this.filterList.SeedSizeList && this.filterList.SeedSizeList.length > 0) ||
      (this.filterList.PackageSizeList && this.filterList.PackageSizeList.length > 0) ||
      (this.filterList.TreatmentList && this.filterList.TreatmentList.length > 0) ||
      (this.filterList.ParentNo != null && this.filterList.ParentNo != '') ||
      (this.filterList.TxtAccountNo != null && this.filterList.TxtAccountNo !== '') ||
      (this.filterList.AccountNo && this.filterList.AccountNo.length > 0) ||
      (this.filterList.AccountName != null && this.filterList.AccountName !== '') ||
      (this.filterList.OrderId != null && this.filterList.OrderId !== '') ||
      (this.filterList.City != null && this.filterList.City !== '') ||
      (this.filterList.State && this.filterList.State.length > 0)) {
      // TO Do Get data and bind in grid
    }

    this.enableDisableSearch();
    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
    this.setFilterTypeList();
  }

  // get filter data
  getFilterData() {
    this.keepFilter();
    if (!this.validateInputText()) {
      return false;
    }

    // enable loader
    this.loaderService.setLoaderStatus(true);

    // get filter data from database

    this.subscription.push(this.substitutionOrderReportService.getSubstitutionOrderReportData(this.filter)
      .subscribe(result => {
        if (result) {
          const data = result as SubstitutionOrderReportData[];
          // set data in Table datasorece
          this.bodyDS = data as any[];
        }

        // set Table Paginator Data Source
        if (this.bodyDS) {
          this.length = this.bodyDS.length;
          this.setPaginatorDS();
          this.paginator.firstPage();
        }
        // disable loader
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); }));
  }

  // set paginator on change
  setPaginatorDS() {
    const recordToSkip = this.pageSize * this.pageIndex;
    this.paginatorDS = this.bodyDS.slice(recordToSkip, recordToSkip + this.pageSize);
  }

  // Set MatPaginator Inputs on paginator change
  onPaginatorChange(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.setPaginatorDS();
  }

  // Table sorting
  sortData(sort: Sort) {
    const data = this.bodyDS.slice();

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.bodyDS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return compare(a[sort.active], b[sort.active], isAsc);
    });

    this.setPaginatorDS();
  }

  // Export data from grid data
  onExportBtnClick() {
    const excelData = [];
    this.loaderService.setLoaderStatus(true);

    setTimeout(x => {
      if (this.bodyDS && this.bodyDS.length > 0) {
        const headerText = this.headerDS.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x.columnfield).headertxt);
        this.bodyDS.forEach(x => {
          const exportData = new Map();

          headerText.forEach(y => {
            switch (y) {
              case 'Order Number': {
                exportData.set(y, x.dealerOrderNumber)
                break;
              }
              case 'Account': {
                exportData.set(y, x.accountNumber)
                break;
              }
              case 'Account Name': {
                exportData.set(y, x.accountName)
                break;
              }
              case 'Account City': {
                exportData.set(y, x.city)
                break;
              }
              case 'Account State': {
                exportData.set(y, x.state)
                break;
              }
              case 'From Product Number': {
                exportData.set(y, x.fromProductNumber)
                break;
              }
              case 'From Product Name': {
                exportData.set(y, x.fromProductName)
                break;
              }
              case 'From Treatment': {
                exportData.set(y, x.fromTreatment)
                break;
              }
              case 'From Seed Size': {
                exportData.set(y, x.fromSeedSize)
                break;
              }
              case 'From Package Size': {
                exportData.set(y, x.fromPackageSize)
                break;
              }
              case 'From Qty Cancelled': {
                exportData.set(y, x.fromQtyCancelled)
                break;
              }
              case 'To Product Number': {
                exportData.set(y, x.toProductNumber)
                break;
              }
              case 'To Product Name': {
                exportData.set(y, x.toProductName)
                break;
              }
              case 'To Treatment': {
                exportData.set(y, x.toTreatment)
                break;
              }
              case 'To Seed Size': {
                exportData.set(y, x.toSeedSize)
                break;
              }
              case 'To Package Size': {
                exportData.set(y, x.toPackageSize)
                break;
              }
              case 'Quantity Substituted': {
                exportData.set(y, x.toQtyTransfered)
                break;
              }
              case 'Remaining Product Number': {
                exportData.set(y, x.remainingProductNumber)
                break;
              }
              case 'Remaining Product Name': {
                exportData.set(y, x.remainingProductName)
                break;
              }
              case 'Remaining Treatment': {
                exportData.set(y, x.remainingTreatment)
                break;
              }
              case 'Remaining Seed Size': {
                exportData.set(y, x.remainingSeedSize)
                break;
              }
              case 'Remaining Package Size': {
                exportData.set(y, x.remainingPackageSize)
                break;
              }
              case 'Remaining Quantity': {
                exportData.set(y, x.remainingQtyTransfered)
                break;
              }
              case 'Substitution Date': {
                exportData.set(y, this.datePipe.transform(x.substitutionDate, 'MM/dd/yyyy'))
                break;
              }
              default: {
                break;
              }
            }
          });

          const obj = this.autoConvertMapToObject(exportData);

          excelData.push(
            obj
          );
        });
        this.excelService.exportExcel(excelData, 'SubstitutionOrderReport');
      }
      this.loaderService.setLoaderStatus(false);
    }, 100);
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  // emit row click event
  redirectToOrder(e: any, rowData: any) {
    let orderType, accountNo, orderId;
    orderType = rowData.orderType;
    accountNo = rowData.accountNumber;
    orderId = rowData.orderId;

    if (rowData.clickable && orderType == 'Dealer Order' && accountNo != 0 && orderId != 0) {
      this.onNavigate('/orders/dealer-order-view' + '/0' + '/' + orderId + '/' + accountNo);
      // this.router.navigate(['/orders/dealer-order-view', 0, orderId, accountNo]);
      // this.router.navigate(['/orders/dealer-order-view', 7023891, 41, 7023891]);
    }
    if (rowData.clickable && orderType == 'Grower Order' && accountNo != 0 && orderId != 0) {
      this.onNavigate('/orders/grower-order-detail' + '/0' + '/' + orderId);
      // this.router.navigate(['/orders/grower-order-detail', 0, orderId]);
      // this.router.navigate(['/orders/grower-order-detail', 7003763, 35]);
    }
  }

  // Navigate
  onNavigate(url) {
    window.open(url, '_blank');
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccountTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // Set Account Table Height
  setAccountTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.quickSearchTopFilter').outerHeight() - $('.tableTopSec').outerHeight() - 200;
      $('.tableComponentOuter').css('max-height', tableHeight + 'px');
    }, 100);
  }

  // validate the substitution date filter on search filters
  validateSubstitutionDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromSubstitutionDate') {
      fromDate = new Date($event.value);
      if (this.filterList.ToSubstitutionDate) {
        var toDate = new Date(this.filterList.ToSubstitutionDate);
        this.fromSubstitutionDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toSubstitutionDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toSubstitutionDate') {
      toDate = new Date($event.value);
      this.fromSubstitutionDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.filterList.FromSubstitutionDate) {
        var fromDate = new Date(this.filterList.FromSubstitutionDate);
        this.toSubstitutionDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromSubstitutionDateFilter = '';
      this.toSubstitutionDateFilter = '';
    }
  }

  // Set Filter Type list on user Id and district selection
  setFilterTypeList() {
    this.searchTypeList = ['Parent Account No', 'Account No', 'Account Name', 'City', 'State/ Province', 'Product Name', 'Marketing Brand',
      'Product Line', 'Seed Size', 'Package Size', 'Treatment', 'Technology', 'Order No', 'Substitution Date'];
  }

  // Search the account details on shipto / Deliverto dropdown
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }
}

// Model and function

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export class commonDDL {
  accounts: any[];
  states: any[];
}

export class SubstitutionOrderReportFilter {
  companyCode: string;
  cropYear: number;
  productName: string;
  productCategory: string;
  marketingBrand: string;
  productLine: string;
  seedSize: string;
  packageSize: string;
  treatment: string;
  parentNo: number;
  account: string;
  accountName: string;
  orderNumber: string;
  city: string;
  state: string;
  fromSubstitutionDate: any;
  toSubstitutionDate: any;
}

export class SubstitutionOrderReportData {
  dealerOrderNumber: string;
  accountNumber: number;
  accountName: string;
  city: string;
  state: string;
  fromProductNumber: string;
  fromProductName: string;
  fromTreatment: string;
  fromSeedSize: string;
  fromPackageSize: string;
  fromQtyCancelled: number;
  toProductNumber: string;
  toProductName: string;
  toTreatment: string;
  toSeedSize: string;
  toPackageSize: string;
  toQtyTransfered: number;
  remainingProductNumber: string;
  remainingProductName: string;
  remainingTreatment: string;
  remainingSeedSize: string;
  remainingPackageSize: string;
  remainingQtyTransfered: number | null;
  substitutionDate: Date;
}
